/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import React, { Fragment } from "react";
import styled from "styled-components";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import EastIcon from "@mui/icons-material/East";
import WestIcon from "@mui/icons-material/West";

const StyledCarouselProvider = styled(({ ...props }) => <CarouselProvider {...props} />)`
  ${({ theme }) => `
  position: relative;
  padding: 0 ${theme.spacing(8)}px;
  margin-top: ${theme.spacing(3)}px;
  height: 320px;

  ${theme.breakpoints.down(410)} {
    .carousel__slider.carousel__slider--horizontal {
      height: inherit;
      > .carousel__slider-tray-wrapper.carousel__slider-tray-wrap--horizontal {
        height: inherit;
        > .carousel__slider-tray.carousel__slider-tray--horizontal {
          height: inherit;
          > .carousel__slide {
            height: inherit;
          }
        }
      }
    }
  }

  .carousel__back-button,
  .carousel__next-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    height: ${theme.spacing(5)}px;
    width: ${theme.spacing(5)}px;
    border: none;
    border-radius: 50%;
    background: none;
    border: 1px solid;

    &:hover {
      cursor: pointer;
      color: ${theme.palette.primary.main};
      // border-color: ${theme.palette.primary.light};
    }
  }

  .carousel__back-button {
    left: 0;
  }

  .carousel__next-button {
    right: 0;
  }

  div {
    outline: none;
  }
  `}
`;

const StyledSlide = styled(({ ...props }) => <Slide {...props} />)`
  ${({ theme }) => `
    text-align: center;

    .product-card {
      max-width: 245px;
      // ${theme.breakpoints.down(410)} {
      //   min-width: 195px;
      // }
      // ${theme.breakpoints.up(410)} {
      //   min-width: 225px;
      // }
      display: inline-block;
      max-height: 330px;
    }
  `}
`;

const StyledStaticSlideList = styled.div`
  ${({ theme }) => `
    margin-top: ${theme.spacing(3)}px;

    display: flex;
    justify-content: center;
    align-items: stretch;

    .product-card {
      max-width: 245px;
      min-width: 225px;
      display: inline-block;
      max-height: 330px;
      margin-right: ${theme.spacing(3)}px;
    }
  `}
`;

const StyledProductRecommendationSlider = ({ slidesList, page }: any) => {
  const theme = useTheme();
  let slidesShown = 5;
  let disabledSliding = false;

  if (useMediaQuery(theme.breakpoints.down("xl"))) {
    slidesShown = 5;
  }

  if (useMediaQuery(theme.breakpoints.down("lg"))) {
    slidesShown = 5;
  }

  if (useMediaQuery(theme.breakpoints.down("md"))) {
    slidesShown = 4;
  }

  if (useMediaQuery(theme.breakpoints.down("sm"))) {
    slidesShown = 2;
  }

  if (useMediaQuery(theme.breakpoints.down("xs")) || page === "OrderConfirmationPage") {
    slidesShown = 1;
  }

  // Check if there are enough slides to cycle through
  if (slidesShown >= slidesList.length) {
    disabledSliding = true;
  }

  return disabledSliding ? (
    <StyledStaticSlideList className="static-product-carousel">
      {slidesList.map((slide: any, i: number) => (
        <Fragment key={i}>{slide}</Fragment>
      ))}
    </StyledStaticSlideList>
  ) : (
    <StyledCarouselProvider
      naturalSlideWidth={230}
      naturalSlideHeight={460}
      visibleSlides={slidesShown}
      step={slidesShown}
      infinite={true}
      dragEnabled={false}
      className="carousel-slider"
      totalSlides={slidesList.length}>
      <Slider>
        {slidesList.map((slide: any, i: number) => (
          <StyledSlide index={i} key={i}>
            {slide}
          </StyledSlide>
        ))}
      </Slider>
      <ButtonBack>
        {/* <ChevronLeftIcon /> */}
        <WestIcon />
      </ButtonBack>
      <ButtonNext>
        {/* <ChevronRightIcon /> */}
        <EastIcon />
      </ButtonNext>
    </StyledCarouselProvider>
  );
};

export { StyledProductRecommendationSlider };
